export const refinementRemovedEventName = 'refinementRemoved';
export const refinementsClearedEventName = 'refinementsCleared';
export const INSTANT_SEARCH_HIERARCHICAL_ATTRIBUTES = ['categories.en-GB.lvl0', 'categories.en-GB.lvl1'];
